<template>
   <div class="fc-mega-menu-panel">
      <div class="fc-mega-menu__group">
         <!-- TODO(content): no eyebrow field exists in the current Contentful model yet —
              hardcoded for now, move to a real field whenever this dropdown gets one. -->
         <h3 class="fc-mega-menu__eyebrow">FusionCharts Suite</h3>
         <ul class="fc-mega-menu__items">
            <li v-for="(item, index) in productLinks(dropdownItems)" :key="index">
               <a
                  v-if="item.header !== 'Yellowfin BI & Analytics'"
                  :href="item.link"
                  itemprop="url"
                  class="fc-mega-menu__item"
                  @click.prevent="goTo(item.link)"
               >
                  <span class="fc-mega-menu__icon">
                     <span v-if="resolveLinkIcon(item)" v-html="resolveLinkIcon(item)"></span>
                     <i v-else :class="item.icon"></i>
                  </span>
                  <span class="fc-mega-menu__label"
                     >{{ item.header
                     }}<span
                        v-if="item.externalProperties && item.externalProperties.isPopular"
                        class="fc-mega-menu__badge fc-mega-menu__badge--popular"
                        >Popular</span
                     ></span
                  >
               </a>
               <a v-else :href="item.link" itemprop="url" class="fc-mega-menu__item">
                  <span class="fc-mega-menu__icon">
                     <span v-if="resolveLinkIcon(item)" v-html="resolveLinkIcon(item)"></span>
                     <i v-else :class="item.icon"></i>
                  </span>
                  <span class="fc-mega-menu__label"
                     >{{ item.header
                     }}<span
                        v-if="item.externalProperties && item.externalProperties.isPopular"
                        class="fc-mega-menu__badge fc-mega-menu__badge--popular"
                        >Popular</span
                     ></span
                  >
               </a>
            </li>
         </ul>
      </div>
   </div>
</template>

<script>
import { resolveLinkIcon } from '../../util/navIcons';

export default {
   name: 'SideBySide',
   props: {
      dropdownItems: {
         type: Array,
         default: () => [],
      },

      sidebysideDropdown: {
         type: Boolean,
         default: false,
      },
   },
   methods: {
      resolveLinkIcon,
      goTo(url) {
         const reload = this.$reloadType(url);
         if (reload) {
            this.$openReload(url);
         } else {
            this.$router.push(url).catch(() => {});
         }
      },
      productLinks(arr) {
         return arr.filter(
            item => !(item.externalProperties && item.externalProperties.comparision)
         );
      },
   },
};
</script>
